import { render } from "./LwMenu.vue?vue&type=template&id=8271283c&scoped=true"
import script from "./LwMenu.vue?vue&type=script&lang=js"
export * from "./LwMenu.vue?vue&type=script&lang=js"

import "./LwMenu.vue?vue&type=style&index=0&id=8271283c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8271283c"]])

export default __exports__